import { memo } from "react";
import { Svg, Path, Rect } from "react-native-svg";
import { themed } from "@tamagui/helpers-icon";
import { jsx, jsxs } from "react/jsx-runtime";
const Icon = props => {
  const {
    color = "black",
    size = 24,
    ...otherProps
  } = props;
  return /* @__PURE__ */jsxs(Svg, {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...otherProps,
    children: [/* @__PURE__ */jsx(Path, {
      d: "M2 7v10",
      stroke: color
    }), /* @__PURE__ */jsx(Path, {
      d: "M6 5v14",
      stroke: color
    }), /* @__PURE__ */jsx(Rect, {
      width: "12",
      height: "18",
      x: "10",
      y: "3",
      rx: "2",
      stroke: color
    })]
  });
};
Icon.displayName = "GalleryHorizontalEnd";
const GalleryHorizontalEnd = memo(themed(Icon));
export { GalleryHorizontalEnd };